import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Pipe({
    name: 'typeName'
})
export class TypeNamePipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }

    transform(value: string, ...args: string[]): string {
        const typeName = args[0];
        const key = 'Types.' + typeName + "." + value;
        return this.translate.instant(key) || value;
    }

}